<template>
  <el-container class="sub-common-page">
    <el-header>
      <sub-header>
        <div class="text-c" slot="body" v-text="title"></div>
        <div class="text-r" slot="action" @click="handJump">
          <el-avatar
            :size="44"
            :src="userInfo.avatar | filterUrl"
            style="cursor: pointer;"
          >
            <img src="~@/assets/imgs/user_icon.png" />
          </el-avatar>
        </div>
      </sub-header>
    </el-header>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import subHeader from '@/components/common/sub-header'
export default {
  data() {
    return {
      title: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    '$route.name'(val) {
      let title = ''
      switch (val) {
        case 'lessonData':
          title = '课堂数据分析'
          break
        case 'raceData':
          title = '竞赛数据分析'
          break
        case 'expDetails':
          title = '课堂实验数据分析'
          break
        case 'taskDetails':
          title = '课堂作业数据分析'
          break
        case 'raceExpDetails':
          title = '竞赛实验数据分析'
          break
        case 'platformStatic':
          title = '平台统计'
          break
        case 'teacherStatic':
          title = '教学统计'
          break
        case 'theuserStatic':
          title = '用户统计'
          break
        default:
          break
      }
      this.title = title
    }
  },
  components: {
    subHeader
  },
  methods: {
    handJump() {
      this.$router.push('/personal/lesson')
    }
  },
  created() {
    let title = ''
    switch (this.$route.name) {
      case 'lessonData':
        title = '课堂数据分析'
        break
      case 'raceData':
        title = '竞赛数据分析'
        break
      case 'expDetails':
        title = '课堂实验数据分析'
        break
      case 'taskDetails':
        title = '课堂作业数据分析'
        break
      case 'raceExpDetails':
        title = '竞赛实验数据分析'
        break
      case 'platformStatic':
        title = '平台统计'
        break
      case 'teacherStatic':
        title = '教学统计'
        break
      case 'theuserStatic':
        title = '用户统计'
        break
      default:
        break
    }
    this.title = title
  }
}
</script>

<style lang="scss">
.sub-common-page {
  height: 100%;
  > .el-header {
    padding: 0;
  }
  > .el-main {
    padding: 0;
  }
}
</style>
